<template>
  <div class="mt-8">
    <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-2">Documentos relacionados</h2>
    <div>
      <BaseAccessibleTable
        :rows="DocumentosRelacionados"
        :columns="tableColumns"
        :enableScroll="false"
        :theadClass="DocumentosRelacionados && DocumentosRelacionados.length > 0 ? '' : 'sr-only'"
      >
        <template #cell-acciones="{ row }">
          <div class="flex flex-row justify-end">
            <base-button-icon
              v-if="row.icon === 'eye' || row.icon === 'eyeslash'"
              @click="showAdjunto(row)"
              :name="row.icon"
              mode="core"
              :ariaLabel="row.icon === 'eye' ? 'Mostrar documento' : 'Ocultar documento'"
            />
            <base-button-icon
              v-if="!trashMode && role !== 'UsuarioConsulta' && hasModulePresentacionesAEAT && isFromAEAT && !row.enviadoAEAT"
              @click="toggleEditTipoDocumento(row)"
              name="editpencil"
              mode="core"
              ariaLabel="Editar documento"
            />
            <base-button-icon
              @click="downloadAdjunto(row)"
              name="download"
              mode="core"
              ariaLabel="Descargar documento"
            />
            <base-button-icon
              v-if="!trashMode && role !== 'UsuarioConsulta' && EsPropietario"
              @click="deleteDocumentoRelacionado(row)"
              name="trash"
              mode="core"
              ariaLabel="Eliminar documento"
            />
          </div>
        </template>
      </BaseAccessibleTable>
    </div>
  </div>
</template>

<script>
import BaseAccessibleTable from '@/components/tables/BaseAccessibleTable.vue'

export default {
  name: 'table-element-docs-relacionados',
  props: {
    DocumentosRelacionados: {
      type: Array,
      default: () => []
    },
    hasModulePresentacionesAEAT: {
      type: Boolean,
      default: false
    },
    isFromAEAT: {
      type: Boolean,
      default: false
    },
    EsPropietario: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
      default: ''
    },
    trashMode: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    BaseAccessibleTable,
  },
  data: function () {
    return {
      
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        { key: 'Nombre', label: 'Documento', minWidth: '200px', align: 'left' },
        { key: 'Extension', label: 'Ext.', width: '60px', align: 'left' }
      ]

      if (this.hasModulePresentacionesAEAT && this.isFromAEAT) {
        columns.push({ key: 'DescripcionTipoDocumento', label: 'Tipo', width: '145px', align: 'left' })
      }

      columns.push({ key: 'acciones', label: 'Acciones', width: '190px', align: 'center' })

      return columns
    }
  },
  methods: {
    showAdjunto (row) {
      this.$emit('showAdjunto', row)
    },
    toggleEditTipoDocumento (row) {
      this.$emit('toggleEditTipoDocumento', row)
    },
    downloadAdjunto (row) {
      this.$emit('downloadAdjunto', row)
    },
    deleteDocumentoRelacionado (row) {
      this.$emit('deleteDocumentoRelacionado', row)
    },
  },
}
</script>
